// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__2uPwK","messages":"Chat_messages__3gAMi","dateDivider":"Chat_dateDivider__2MfdF"};